export function initMicroClusters() {
  const $wrapper = $('.p-lp-microcluster__categories-wrapper');
  const $categories = $wrapper.find('.p-lp-microcluster__categories');

  let selectedSectionTagSlug = window.__TGV_ROOM_TAG;

  if (!$categories.length) {
    return;
  }

  // Track visibility of microcluster section
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        App.track.event('location_page_interaction', {
          section: 'microcluster',
          element: '',
          element_value: window.__TGV_ROOM_TAG,
          interaction: 'visible',
        });
        observer.unobserve(entry.target); // Only track once
      }
    });
  }, { threshold: 0.1 });

  observer.observe($wrapper[0]);

  // Track room card clicks
  $(document).on('click', '.p-lp-microcluster__room', () => {
    App.track.event('location_page_interaction', {
      section: 'microcluster',
      element: 'section_room_card',
      element_value: selectedSectionTagSlug,
      interaction: 'click',
    });
  });

  // Track "Show more venues" button clicks
  $(document).on('click', '.p-lp-microcluster__cta', () => {
    App.track.event('location_page_interaction', {
      section: 'microcluster',
      element: 'section_show_more',
      element_value: selectedSectionTagSlug,
      interaction: 'click',
    });
  });

  $(document).on('change', 'input[name="microcluster-pill"]', () => {
    const id = $("input[name='microcluster-pill']:checked").attr('id');
    const $section = $(`.p-lp-microcluster__category[data-category-id='${id}']`);

    $section[0]?.scrollIntoView(
      { behavior: 'smooth',
        block: 'center',
        inline: 'start',
      },
    );

    selectedSectionTagSlug = $section.data('tag-slug');
    App.track.event('location_page_interaction', {
      section: 'microcluster',
      element: 'section_pill',
      element_value: selectedSectionTagSlug,
      interaction: 'click',
    });
  });

  const categories = $categories[0];

  const $arrowLeft = $wrapper.find('.c-box-carousel-arrow--left');
  const $arrowRight = $wrapper.find('.c-box-carousel-arrow--right');

  const updateArrows = () => {
    const TOLERANCE = 10; // Tolerance in px for scroll end detection
    $arrowLeft.toggleClass('c-box-carousel-arrow--invisible', categories.scrollLeft - TOLERANCE <= 0);
    $arrowRight.toggleClass(
      'c-box-carousel-arrow--invisible',
      categories.scrollLeft + categories.clientWidth + TOLERANCE >= categories.scrollWidth,
    );
  };

  const SCROLL_STEP = 390;

  $arrowRight.on('click', () => {
    categories.scrollBy({
      left: SCROLL_STEP,
      behavior: 'smooth',
    });

    App.track.event('location_page_interaction', {
      section: 'microcluster',
      element: 'section_arrow',
      element_value: selectedSectionTagSlug,
      interaction: 'click',
    });
  });

  $arrowLeft.on('click', () => {
    categories.scrollBy({
      left: -SCROLL_STEP,
      behavior: 'smooth',
    });

    App.track.event('location_page_interaction', {
      section: 'microcluster',
      element: 'section_arrow',
      element_value: selectedSectionTagSlug,
      interaction: 'click',
    });
  });

  updateArrows(0);
  categories.addEventListener('scrollend', () => {
    updateArrows();
  });
}
